export function ggzoEmblEchelonToText(number: number) {
    const echelonTexts = [
        'Onbekend',
        'Geen vervolgtraject',
        'Maatschappelijk werk',
        'Huisartsenzorg met praktijkondersteuner GGZ',
        'Generalistische Basis GGZ Kort (BK)',
        'Generalistische Basis GGZ Middel (BM)',
        'Generalistische Basis GGZ Intensief (BI)',
        'Generalistische Basis GGZ Chronisch (BC)',
        'Specialistische GGZ',
        'Anders (bijv. alternatieve geneeswijze)',
        'Generalistische Basis GGZ',
    ];
    const text = echelonTexts[number - 1];

    return text ? text : `Onbekende echelon code ${number} ontvangen`;
}
